import { doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { app } from '../../util/firebase';

const UpdatePharmacie = (props) => {
    
    const [name,setName] = useState("")
    const [adresse,setAdresse] = useState("")
    const [number,setNumber] = useState("")
    const [email,setEmail] = useState("")
    const [password,setPassword] = useState("")
    const [currentUser,setCurrentUser] = useState(null)
    const [img,setImg] = useState(null)
    const [isChecked,setIsChecked] = useState(false)

    let randomNumber = Math.round(Math.random() * 10000)
    const navigate = useNavigate()

    useEffect(()=>{
        onSnapshot(doc(getFirestore(app),"users",props.pharmID),(snap)=>{
            let pharm = snap.data()
            setCurrentUser(pharm)
            setName(pharm.userName)
            setAdresse(pharm.adresse)
            setEmail(pharm.email)
            setPassword(pharm.password)
            setNumber(pharm.phoneNumber)
            setIsChecked(true)
            
        })
    },[])
    const submit = (e)=>{
        e.preventDefault()

        let user = currentUser
        user.userName = name
        user.phoneNumber = number
        user.adresse = adresse

        if(isChecked===true){
            setDoc(doc(getFirestore(app),"users",props.pharmID),user)
            .then(result=>{
                alert('Les changement sont pris en compte')
                navigate(-1)
            })
            .catch(err=>alert(err))
        }else{
            let imgUrl = user.imgSrc.substring(72,user.imgSrc.length - 10)
            imgUrl = imgUrl.replaceAll("%2F","/")
    
            let storageRef = ref(getStorage(app),imgUrl)
            uploadBytes(storageRef,img)
            .then((result)=>{
                setDoc(doc(getFirestore(app),"users",props.pharmID),user)
                .then(result=>{
                    alert('Les mises a jours sont pris en compte')
                    navigate(-1)
                })
                .catch(err=>alert(err))
            })
            .catch(err=>alert(err))
        }
    }
    const archiveUser = ()=>{
        let user = currentUser
        user.isArchived = true
        setDoc(doc(getFirestore(app),"users",props.pharmID),user)
        .then((result)=>{
            alert('Le pharmacie '+currentUser.userName+' a bin été archivé')
            navigate(-1)
        })
    }
    return (
        <div>
            <div>
                <div className='col-12 col-md-6 m-auto shadow p-3 my-3 my-md-5 '>
                    <h2 className='text-center'>Mettre a jours la pharmacie</h2>
                    <form onSubmit={e=>submit(e)}>
                        <input required className='form-control my-3' type="text" placeholder='Nom de la pharmacie' value={name} onChange={e=>setName(e.target.value)}></input>
                        <input required className='form-control my-3' type="text" placeholder='Addresse' value={adresse} onChange={e=>setAdresse(e.target.value)}></input>
                        <input required className='form-control my-3' type="number" placeholder='Numéro de téléphone' value={number} onChange={e=>setNumber(e.target.value)}></input>
                        <input disabled required className='form-control my-3' type="email" placeholder='Email' value={email} onChange={e=>setEmail(e.target.value)}></input>
                        <input disabled required className='form-control my-3' type="password" placeholder='Mot de passe' value={password} onChange={e=>setPassword(e.target.value)}></input>
                        <label className='row p-3'>
                            <div className='col-9'>
                                <input type="checkbox" checked={isChecked} onChange={e=>setIsChecked(!isChecked)}></input>
                                Garder l'image actuel
                            </div>

                            {isChecked? (<div className='col-3' style={{minHeight:'94px',backgroundImage:'url('+currentUser.imgSrc+')',backgroundSize:'cover',backgroundPosition:'center'}}></div>) :(null)}
                        </label>
                        {isChecked? (null) :(<input required className='form-control my-3' type="file" onChange={e=>setImg(e.target.files[0])}></input>)}
                        <button className='btn btn-primary col-12'>Mettre a jours la pharmacie</button>
                        <button type='button' className='btn btn-danger col-12 my-2' onClick={archiveUser}>Archiver la Pharmacie</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdatePharmacie;